
        <p class="input-title" *ngIf="title">{{ title }}</p>
        <label class="switch-wrapper">{{ label }}
            <input type="checkbox"
                   [(ngModel)]="value"
                   [attr.checked]="value"
                   (blur)="onBlur()"
                   [disabled]="disabled">
            <span class="checkmark"></span>
        </label>
        <p class="input-error" *ngIf="error">{{ error }}</p>
    


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/inputs/form-switch.component.ts.FormSwitchComponent.html